import React from 'react';

const AboutUs = () => {
    return (
        <div className="text-center">
            <h3>We are one of the leading internal travel agency</h3>
            <p>Almost 5000 people take our service yearly. We are the most trust worthy agency in Bangladesh. We ensure client satisfaction. We are also very budget friendly and flexible in terms of client's choice and demands. So take a step forward and try out our services. Happy tarvelling </p>

        </div>
    );
};

export default AboutUs;